import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

export default function TermsOfService() {
  const terms = [
    {
      id: "01",
      title: "Service Agreement",
      content: "By accessing pcworldraipur.in or downloading our specialized APK, you agree to engage with PC World Raipur's B2B services, including enterprise hardware procurement, networking installation, and Annual Maintenance Contracts (AMC)."
    },
    {
      id: "02",
      title: "Hardware & Warranty",
      content: "All enterprise servers, CCTV systems, and networking hardware are subject to the manufacturer's warranty. PC World Raipur facilitates B2B support but is not liable for data loss occurring due to hardware failure without a valid AMC."
    },
    {
      id: "03",
      title: "Quotation & Payments",
      content: "Quotations for IT infrastructure are valid for 7 days unless specified otherwise. Prices for enterprise-grade components are subject to market volatility. Payments must be processed through authorized corporate channels."
    },
    {
      id: "04",
      title: "Software & APK Usage",
      content: "The 'PC World DownloadV2.apk' is provided as a diagnostic and support tool. Users are prohibited from reverse-engineering the application or using it for any unauthorized network scanning beyond their own infrastructure."
    },
    {
      id: "05",
      title: "Limitation of Liability",
      content: "PC World Raipur shall not be held liable for indirect, incidental, or consequential damages resulting from the use of our infrastructure solutions or technical support services beyond the scope of the signed service agreement."
    }
  ];

  return (
    <div className="bg-white min-h-screen pt-12 pb-20 px-6 overflow-hidden">
      {/* Background Decorative Element */}
      <div className="fixed top-0 right-0 w-[500px] h-[500px] bg-blue-50/50 blur-[150px] rounded-full translate-x-1/2 -translate-y-1/2 -z-10" />

      <div className="max-w-5xl mx-auto">
        
        {/* HERO SECTION */}
        <motion.div 
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          className="mb-20 border-l-4 border-blue-600 pl-8"
        >
          <h4 className="text-blue-600 font-black uppercase tracking-[0.5em] text-[10px] mb-3">
            Operational Guidelines
          </h4>
          <h1 className="text-5xl md:text-7xl font-black text-slate-900 uppercase tracking-tighter leading-none">
            Terms of <span className="text-slate-300">Service</span>
          </h1>
          <p className="text-slate-500 mt-6 font-medium max-w-2xl text-lg">
            Review the legal framework governing our partnership. We ensure transparent B2B transactions and reliable IT infrastructure support.
          </p>
        </motion.div>

        {/* TERMS LIST */}
        <div className="space-y-4">
          {terms.map((term, index) => (
            <motion.div
              key={term.id}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              className="group relative p-8 rounded-[2rem] border border-slate-100 bg-white hover:border-blue-200 transition-all duration-500 overflow-hidden"
            >
              <div className="flex flex-col md:flex-row md:items-center gap-6 relative z-10">
                <span className="text-4xl font-black text-slate-100 group-hover:text-blue-50 transition-colors duration-500">
                  {term.id}
                </span>
                <div className="flex-1">
                  <h3 className="text-xl font-black text-slate-900 uppercase tracking-tight mb-2 flex items-center gap-3">
                    {term.title}
                    <div className="h-1 w-1 rounded-full bg-blue-600 opacity-0 group-hover:opacity-100 transition-opacity" />
                  </h3>
                  <p className="text-slate-600 leading-relaxed font-medium">
                    {term.content}
                  </p>
                </div>
              </div>
              
              <div className="absolute top-0 right-0 w-32 h-32 bg-slate-50 rounded-full translate-x-16 -translate-y-16 group-hover:bg-blue-50 transition-colors" />
            </motion.div>
          ))}
        </div>

        {/* ACCEPTANCE BOX */}
        <motion.div 
          initial={{ opacity: 0, scale: 0.95 }}
          whileInView={{ opacity: 1, scale: 1 }}
          className="mt-20 p-12 rounded-[3rem] bg-gradient-to-br from-slate-900 to-slate-800 text-white relative overflow-hidden"
        >
          <div className="relative z-10">
            <h3 className="text-2xl font-black uppercase tracking-tight mb-4 text-blue-400">Acknowledgment</h3>
            <p className="text-slate-400 max-w-xl mb-8 font-medium">
              By continuing to use our platform or hardware services at Nagdev Plaza, you acknowledge that you have read and understood these terms.
            </p>
            <div className="flex flex-wrap gap-4">
              <Link 
                to="/contact"
                className="bg-white text-slate-950 px-8 py-4 rounded-2xl font-black text-[11px] uppercase tracking-widest hover:bg-blue-600 hover:text-white transition-all shadow-xl"
              >
                Inquire for Details
              </Link>
              <button 
                onClick={() => window.print()}
                className="border border-white/20 text-white px-8 py-4 rounded-2xl font-black text-[11px] uppercase tracking-widest hover:bg-white/10 transition-all"
              >
                Print PDF 🖨️
              </button>
            </div>
          </div>
          
          <div className="absolute bottom-0 right-0 w-64 h-64 bg-blue-600/20 blur-3xl rounded-full translate-x-1/2 translate-y-1/2" />
        </motion.div>
      </div>
    </div>
  );
}